import React from 'react'
import { Icon, Popconfirm } from 'antd'

export const tableColumns = props => [
    {
        title: 'Id',
        dataIndex: 'user_id',
        render: text => <span className="gx-link" onClick={() => props.showUserModal(text)}>{text}</span>
    },
    {
        title: 'Username',
        dataIndex: 'username'
    },
    {
        title: 'Connected',
        dataIndex: 'is_connected',
        render: is_connected =>
            is_connected === true ? (
                <span>
                    <span role="img" aria-label="blue dot">
                        🔵
                    </span>{' '}
                    Online
                </span>
            ) : (
                <span>
                    <span role="img" aria-label="red dot">
                        🔴
                    </span>{' '}
                    Offline
                </span>
            )
    },
    {
        title: 'Last seen at',
        dataIndex: 'last_seen',
        render: last_seen => {
            if (last_seen != null) {
                let d = new Date(last_seen)
                return <span>{d.toDateString()}</span>
            } else {
                return <span>Never connected</span>
            }
        }
    },
    {
        title: 'Delete',
        render: (userId, record) => {
            return (
                <Popconfirm title="Sure to delete?" onConfirm={() => props.handleDelete(record.user_id)}>
                    <a>
                        <Icon type="delete" />
                    </a>
                </Popconfirm>
            )
        }
    }
]
